import React from 'react';
import { Box } from '@mui/material';
import { IconButtonStyledOutlined } from '@/components/common/iconButtonStyledOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export interface ActionsMenuCellProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  size?: 'small' | 'medium';
  ariaLabel?: string;
  id?: string;
  menuId?: string;
  menuOpen?: boolean;
}

const ActionsMenuCell: React.FC<ActionsMenuCellProps> = ({
  onClick,
  size = 'small',
  ariaLabel,
  id,
  menuId,
  menuOpen = false,
}) => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IconButtonStyledOutlined
        size={size}
        id={id}
        aria-label={ariaLabel}
        aria-haspopup={menuId ? 'menu' : undefined}
        aria-controls={menuId && menuOpen ? menuId : undefined}
        aria-expanded={menuId ? menuOpen : undefined}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        // A DataGrid cell cancels Space to scroll a page, which would stop
        // the button from opening its menu.
        onKeyDown={(e) => {
          if (e.key === ' ') e.stopPropagation();
        }}
      >
        <MoreVertIcon />
      </IconButtonStyledOutlined>
    </Box>
  );
};

export default ActionsMenuCell;
